import { useEffect } from "react";
import { CustomCarousel } from "components";
import { AppDispatch, RootState } from "store";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartners } from "store/partners/partners.slice";

import "./Partners.scss";
import PartnerCard from "./PartnerCard";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Partners = ({ title = true }: { title?: boolean }) => {
  const { t } = useTranslation("home", { useSuspense: false });
  const [device, orientation] = useEffectDeviceAndOrientation();
  const { loading, list } = useSelector((store: RootState) => store.partners);
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPartners(null));
  }, [dispatch]);

  if (loading) {
    return <LoadingOutlined />;
  }
  return (
    <div className="Partners-Box">
      {title === true && <h2 className="Page-Title">{t("nasi_partneri")}</h2>}
      <CustomCarousel
        device_type={device}
        items_computer={7}
        items_tablet={4}
        items_mobile={3}
        slides_computer={1}
        slides_tablet={1}
        slides_mobile={1}
        partial_computer={0}
        partial_tablet={0}
        partial_mobile={0}
        show_dots={false}
        arrow_computer={true}
        arrow_tablet={false}
        arrow_mobile={false}
      >
        {list.data.map(
          (
            partner: {
              post_title: String;
              slug: String;
              post_description: String;
              background_image: String;
            },
            id: number
          ) => {
            return (
              <PartnerCard
                style={{ width: "100%", height: "100%" }}
                title={partner.post_title}
                description={partner.post_description}
                picture={partner.background_image}
                slug={partner.slug}
                device={device}
                orientation={orientation}
                key={id}
              />
            );
          }
        )}
      </CustomCarousel>
    </div>
  );
};
export default Partners;
